import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { API } from 'aws-amplify'
import { b64toFile } from '../shared/files'
import { saveAs } from 'file-saver'
import FilesPanel from '../components/FilesPanel'

class HomeContainer extends Component {

  state = {
    isLoading: true,
    groupedFiles: {},
    errorOpeningFile: false
  }

  async componentDidMount() {
    if (this.props.isAuthenticated) {
      let files = []
      const requestOptions = {
        headers: {
          'x-user-email': this.props.authenticatedUser
        }
      }

      try {
        files = await API.get('files', '/files', requestOptions)
        files.sort((a, b) => (a.sendingDate < b.sendingDate) ? 1 : -1)
      } catch (e) {
        try {
          console.info('Avoid timeout by lambda cold start issue')
          files = await API.get('files', '/files', requestOptions)
          files.sort((a, b) => (a.sendingDate < b.sendingDate) ? 1 : -1)
        } catch(e2) {
          alert('Ocorreu um erro ao carregar suas faturas/boletos. Por favor atualize a pÃ¡gina clicando F5.')
        }
      }

      const groupedFiles = {}
      files.forEach(file => {
        if(groupedFiles[file.sendingDate]) {
          groupedFiles[file.sendingDate].files.push(file)
        } else {
          groupedFiles[file.sendingDate] = {}
          groupedFiles[file.sendingDate].files = [file]
        }
      })
      this.setState({ groupedFiles, isLoading: false })
    }
  }

  openFile = async (file) => {
    try {
      const bill = await this._getBill(file, true)
      if (bill && bill.url) {
        this._openExternalUrl(bill.url)
        return
      }
      this._openPdf(this._getBase64Content(bill))
    } catch (e) {
      this.setState({ errorOpeningFile: true })
      console.error('erro', e)
    }
  }

  downloadFile = async (file) => {
    try {
      const bill = await this._getBill(file, true)
      const blob = this._createPdfBlob(this._getBase64Content(bill), file.name)
      saveAs(blob, `${file.name}`)
    } catch (e) {
      alert('Erro inesperado! Contate o Administrador.')
      console.error('erro', e)
    }
  }

  async _getBill(file, inline = false, asBase64 = true) {
    const inlineParam = inline ? '&inline=true' : ''
    const base64Param = asBase64 ? '&asBase64=true' : ''
    return await API.get('files', `/files/download/${file.fileId}?recipientId=${file.recipientId}&sendingId=${file.sendingId}&plugin=${file.plugin}${inlineParam}${base64Param}`)
  }

  _openExternalUrl(url) {
    const externalWindow = window.open(url, '_blank')
    this.setState({ errorOpeningFile: !externalWindow })
  }

  _openPdf(fileContent) {
    const blob = this._createPdfBlob(fileContent, 'documento.pdf')
    const blobUrl = URL.createObjectURL(blob)
    const pdfWindow = window.open(blobUrl, '_blank')
    this.setState({ errorOpeningFile: !pdfWindow })
  }

  _createPdfBlob(fileContent, fileName) {
    return b64toFile(fileContent, fileName, 'application/pdf')
  }

  _getBase64Content(response) {
    if (response && response.base64) {
      return response.base64
    }
    if (typeof response === 'string') {
      return response
    }
    throw new Error('Resposta do arquivo invalida')
  }

  render() {
    return (
      <FilesPanel
        isLoading={this.state.isLoading}
        isAuthenticated={this.props.isAuthenticated}
        groupedFiles={this.state.groupedFiles}
        openFile={this.openFile}
        downloadFile={this.downloadFile}
        errorOpeningFile={this.state.errorOpeningFile} />
    )
  }
}

HomeContainer.propTypes = {
  isAuthenticated: PropTypes.bool,
  authenticatedUser: PropTypes.string
}

export default HomeContainer
